import * as React from "react";
import { Button, Row, Col } from "reactstrap";
import { Choice } from "../../models/choice";

export interface IMultipleChoiceProp<T> {
    title: string;
    paragraph: string;
    choices: Choice<T>[];
    collumns?: number;
}

export class MultipleChoiceForm<T> extends React.Component<
  IMultipleChoiceProp<T>,
  {}
> {
  next(choice: Choice<T>) {
    choice.action(choice.getValue());
  }

  createChoices() {
    let choices = [];
      let classes = "";
      if (this.props.collumns == 1) {
          classes += " Col-12";
      }
      else if (this.props.collumns == 2) {
          classes += " col-6 col-sm-4 col-md-3 py-2 px-2";
      }
      else if (this.props.collumns == 3) {
          classes += " col-6 col-sm-4 col-md-4 py-2 px-2";
      }
      else if (this.props.collumns == 4) {
          classes += " col-6 col-sm-6 col-md-3 py-2 px-2";
      }
      else if (this.props.collumns == 6) {
          classes += " col-6 col-sm-6 col-md-3 py-2 px-2";
      } else {
          classes = "col-6 col-sm-4 col-md-3 py-2 px-2"
      }
    for (let i = 0; i < this.props.choices.length; i++) {
      let choice = this.props.choices[i];
      choices.push(
        <Col key={i} className={classes}>
          <Button key={i} className="choice" onClick={() => this.next(choice)}>
            {choice.getTitle()}
          </Button>
        </Col>
      );
    }

    return choices;
  }

  render() {
    return (
      <div>
        <Row>
          <Col className="text-center">
            <h3 className="text-uppercase">{this.props.title}</h3>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <p>{this.props.paragraph}</p>
          </Col>
        </Row>
        <Row className="justify-content-center">{this.createChoices()}</Row>
      </div>
    );
  }
}
